module.exports = __webpack_public_path__ + "static/19-4-013e665751a8ed9bbf031aebb27034a8.jpg";